export default "__VITE_ASSET__CAcqfg8t__"